import { jsx as e } from "react/jsx-runtime";

import r from "@ui-components-3/ui/lib/components/FormControl";

import o from "@ui-components-3/ui/lib/components/Select";

import { forwardRef as t, useRef as n, useCallback as a } from "react";

import { useFormContext as i, useController as l } from "react-hook-form";

const s = t((({label: t, name: s, className: m, selectClassName: c, formControlProps: p, shouldShowError: u, initialScrollOptionIndex: f, ...h}, d) => {
    const b = n(!1), {formState: {isSubmitted: S}} = i(), {field: g, fieldState: {error: N, isTouched: x}} = l({
        name: s
    }), {helper: F, helperVariant: V, ...v} = p || {}, w = !(!N?.message || !x && !S && !u), {onFocus: C} = h, T = a((e => {
        C?.(e), !b.current && "number" == typeof f && f >= 0 && setTimeout((() => {
            const r = e.target.nextSibling;
            if (r instanceof HTMLElement && r?.children?.length >= f) {
                const e = r.children[f];
                e && (e.scrollIntoView({
                    behavior: "instant",
                    block: "start"
                }), b.current = !0);
            }
        }));
    }), [ f, C ]);
    return e(r, {
        ...v,
        label: t,
        className: m,
        helper: w ? N?.message : F,
        helperVariant: w ? "error" : V,
        children: e(o, {
            rawValueMode: !0,
            ...h,
            ...g,
            onFocus: T,
            variant: w ? "error" : h.variant,
            className: c,
            ref: d
        })
    });
}));

s.displayName = "FormSelect";

export { s as default };
//# sourceMappingURL=FormSelect.js.map
